// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DU6g3hH2ZLAxYt4_JWDQ{padding:15px}.CKNU_wSYJRNRiZCsKfiZ{margin-bottom:15px}`, "",{"version":3,"sources":["webpack://./src/components/cards/defaults/CardWithTitle/styles.module.sass"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACF,sBACE,kBAAA","sourcesContent":[".card\n  padding: 15px\n.title\n  margin-bottom: 15px\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `DU6g3hH2ZLAxYt4_JWDQ`,
	"title": `CKNU_wSYJRNRiZCsKfiZ`
};
export default ___CSS_LOADER_EXPORT___;
